var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "world-map-mobile" }, [
    _c(
      "div",
      { staticClass: "container" },
      [
        _c("h2", { staticClass: "titre-section" }, [_vm._t("titre")], 2),
        _vm._v(" "),
        _c(
          "ul",
          {
            staticClass: "territory-filters",
            class: "select" + _vm.activeIndex,
          },
          [
            _c("li", [
              _c(
                "a",
                {
                  attrs: { href: "" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.selectFilter(0)
                    },
                  },
                },
                [_vm._t("filter1")],
                2
              ),
            ]),
            _vm._v(" "),
            _c("li", [
              _c(
                "a",
                {
                  attrs: { href: "" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.selectFilter(1)
                    },
                  },
                },
                [_vm._t("filter2")],
                2
              ),
            ]),
            _vm._v(" "),
            _c("li", [
              _c(
                "a",
                {
                  attrs: { href: "" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.selectFilter(2)
                    },
                  },
                },
                [_vm._t("filter3")],
                2
              ),
            ]),
          ]
        ),
        _vm._v(" "),
        _c("transition", { attrs: { name: "fadeSwipe", mode: "out-in" } }, [
          _vm.activeIndex === 0
            ? _c(
                "div",
                { key: "desc1", staticClass: "bloc-content" },
                [_vm._t("0")],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.activeIndex === 1
            ? _c(
                "div",
                { key: "desc2", staticClass: "bloc-content" },
                [_vm._t("1")],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.activeIndex === 2
            ? _c(
                "div",
                { key: "desc3", staticClass: "bloc-content" },
                [_vm._t("2")],
                2
              )
            : _vm._e(),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }